import React from 'react'

const ArcheivedFiles = () => {
  return (
    <div>Archeived Files</div>
  )
}

export default ArcheivedFiles